<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col :md="showResult ? 12 : 6">
        <b-card>
          <div slot="header">
            <strong><i class="fa fa-align-justify"/> Affectation grille AT produit sur mesure</strong>
          </div>
          <b-row>
            <b-col :md="showResult ? 4 : 12" class="borded-right">
              <b-form>
                <b-form-group label="SIREN" label-for="siren">
                  <b-input-group>
                    <b-form-input
                      id="siren"
                      type="text"
                      :class="{hasError: errors.siren !== ''}"
                      v-model="siren"
                    />
                  </b-input-group>
                  <span class="field-error">{{ errors.siren }}</span>
                </b-form-group>
                <div class="mt-1" slot="footer">
                  <b-button type="button" @click.prevent="search" size="md" class="pull-right" variant="primary">
                    <i class="fa fa-search"/> Recherche
                  </b-button>
                </div>
              </b-form>
              <span>
                - <a @click="downloadSirenEffectif()" target="_BLANK" class="bleu_clair"> Télécharger la liste des SIREN SM et leur grille</a><br>
              </span>
            </b-col>
            <b-col md="8" v-if="showResult === true">
              <b-form v-if="allGrilleSm.length > 0">
                <b-row class="mb-1" v-if="grilleProduitSiren !== null && libelleGrilleProduitSiren != null">
                  <b-col>
                    <label>Le SIREN {{ sirenEntreprise }} est déjà paramétré pour la grille <span><b style="color:#f27d7c;">{{ libelleGrilleProduitSiren }}</b></span>, vous pouvez néanmoins le modifier</label>
                  </b-col>
                </b-row>
                <b-card no-body>
                  <div class="card-smallHeader card-header-action mb-2">
                    <span style="color:#d9418b" class="mr-2"> <b>Affectation de la grille de salaire pour la structure {{ raisonSociale }}</b></span>
                  </div>
                  <b-card-body>
                    <b-row class="mb-1">
                      <b-col sm="1">
                        <label for="siren"><strong>SIREN : </strong></label>
                      </b-col>
                      <b-col sm="2">
                        <label>{{ sirenEntreprise }}</label><br>
                      </b-col>
                      <b-col sm="2">
                        <label for="libelle_grille"><strong>Type de grille : </strong></label>
                      </b-col>
                      <b-col sm="7">
                        <b-form-group>
                          <b-form-radio v-for="grilleSm of allGrilleSm" v-model="grilleProduitSiren" :key="grilleSm.id" :name="`radio-grille-sm-${grilleSm.id}`" :value="grilleSm.id">
                            {{ grilleSm.libelle }}
                          </b-form-radio>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-card-body>
                  <div class="mt-1" slot="footer">
                    <b-button type="button" @click.prevent="changeGrilleProduitSm()" size="md" class="pull-right" variant="primary">
                      <i class="fa fa-save"/> Affecter la grille
                    </b-button>
                    <b-button type="button" @click.prevent="cancel" size="md" class="pull-right mr-3" variant="secondary">
                      <i class="fa fa-close"/> Annuler
                    </b-button>
                  </div>
                </b-card>
              </b-form>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from '../../utils/auth';
  import { espaceEmployeurRules as rules, hasRule } from "@/utils/rulesHelper";
  import {downloadFile, isEmpty} from "@/utils/fileHelper";

  export default {
  data() {
    return {
      siren: '',
      sirenEntreprise: '',
      allGrilleSm: [],
      grilleProduitSiren: '',
      libelleGrilleProduitSiren: '',
      raisonSociale: '',
      showResult: false,
      errors: {
        siren: ''
      }
    }
  },
  mounted() {

  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common['Authorization'] = getIdToken() + ' ' + getAccessToken()
    this.$axios.defaults.headers.common['Accept'] = 'application/json';
    this.$axios.defaults.headers.common['Provider'] = getProvider();
  },
  methods: {
    search() {
      if (this.validateData()) {
        this.$store.commit('IS_LOADING', true)
        let self = this
        this.$axios
          .get("/espaceEmployeur/grille-sm/search/" + this.siren)
          .then(response => {
            if (response.data.errorMessage) {
              this.errors.siren = "Le SIREN est inconnu de CeV"
              this.showResult = false
              this.$store.commit("IS_LOADING", false)
            }
            else {
              this.$store.commit("IS_LOADING", false)
              this.showResult = true
              this.grilleProduitSiren = response.data.grilleProduitSm !== null ? response.data.grilleProduitSm.id : null
              this.libelleGrilleProduitSiren = response.data.grilleProduitSm !== null ? response.data.grilleProduitSm.libelle : null
              this.allGrilleSm = response.data.allGrilleSm
              this.raisonSociale = response.data.entreprise.raison_sociale
              this.sirenEntreprise = response.data.entreprise.siren
            }
          })
          .catch(function (error) {
            self.$store.commit("IS_LOADING", false);
            self.$swal({
              position: "top",
              type: "error",
              title: "Attention !!",
              text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
              showConfirmButton: false,
              timer: 5000
            });
          });
      }
    },
    validateData() {
      this.clearErrors()
      let valid = true
      if (this.siren !== '') {
        this.siren = this.siren.replaceAll(' ', '')
        if (this.siren.length < 9 || this.siren.length > 9) {
          this.errors.siren = "Le SIREN doit contenir 9 caractères"
          valid = false;
        }
        if (/^\d+$/.test(this.siren) === false) {
          this.errors.siren = 'Le SIREN ne doit contenir que des chiffres'
          valid = false
        }
      } else {
        this.errors.siren = "Le SIREN est obligatoire"
        this.allGrilleSm = ''
        valid = false
      }
      return valid;
    },
    validateGrilleData() {
      this.clearErrors();
      let valid = true
      if (this.grilleProduitSiren === "") {
        this.errors.grilleProduitSiren = "Le type de grille est obligatoire"
        this.allGrilleSm = ''
        valid = false
      }
      return valid;
    },
    clearErrors() {
      this.errors.siren = ""
    },
    changeGrilleProduitSm() {
      if (this.validateGrilleData()) {
        this.$store.commit('IS_LOADING', true)
        let self = this
        let dataPost = {}
        dataPost.grilleProduitSiren = this.grilleProduitSiren
        let selectedGrilleSm = this.allGrilleSm.find(grilleSm => grilleSm.id === this.grilleProduitSiren);
        this.$axios.post('/espaceEmployeur/grille-sm/store/' + this.siren, dataPost)
          .then(response => {
            this.$store.commit('IS_LOADING', false)
            this.libelleGrilleProduitSiren = selectedGrilleSm.libelle
            this.$swal({ position: 'top', type: 'success', title: 'Affectation de grille avec succès', text: 'Affectation de la grille ' + selectedGrilleSm.libelle + ' prise en compte pour le SIREN ' + this.siren, showConfirmButton: false, timer: 5000 })
          })
          .catch(function (error) {
            self.$store.commit('IS_LOADING', false)
            self.$swal({ position: 'top', type: 'error', title: 'Attention !!', text: 'Un problème est survenu, merci de contacter l\'administration', showConfirmButton: false, timer: 5000 })
          })
      }
    },
    cancel() {
      this.siren = '',
      this.showResult = false
    },
    downloadSirenEffectif() {
      let dateDuJour = new Date();
      let dateExport = dateDuJour.toLocaleDateString("fr-FR")
      this.$store.commit('IS_LOADING', true);
      this.$axios.post('/espaceEmployeur/grille-sm/extraction', { responseType: 'arraybuffer' })
        .then((response) => {
          this.$store.commit('IS_LOADING', false);
          downloadFile(response, 'Export-SIREN-SM_' + dateExport, 'csv');
        })
        .catch(error => {
          self.$store.commit('IS_LOADING', false);
          let errorText = "Une erreur est survenue. Si le problème persiste, merci de faire un ticket au support DOSI."
          self.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: errorText,
            showConfirmButton: false,
            timer: 5000
          })
        });
    }
  }
}
</script>

<style scoped>
  .bleu_clair {
    cursor: pointer;
    color: #1e8eb5 !important;
  }
</style>
